import React from 'react';
import RequestDetails from './requestorder';
import Add from './add';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server'
import { Button, Grid, Pagination } from 'semantic-ui-react';
import Followup from './followup';
import Checkbox from '@material-ui/core/Checkbox';
import Samplerequest from './samplerequest';
import Showpendingstocks from './showpendingstocks';
import Voucher from './voucher';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import ReadCookie from '../../../functions/readcookies';

class Title extends React.Component {

  state = {
    data: [],
    viewOpen: false,
    datas: [],
    addDialog: false,
    load: false,
    message: '',
    checkBox: [],
    openFollowup: false,
    pageNumber: 0,
    totalPages: 50,
    boundaryRange: 1,
    siblingRange: 1,
    showEllipsis: true,
    showFirstAndLastNav: true,
    showPreviousAndNextNav: true,
    orderElement: 'timstamp',
    sortingOrder: 'DESC',
    branchData: [],
  }

  componentDidMount() {
    this.getBranchs();
    this.getPurchaseRequest(1, this.state.orderElement, this.state.sortingOrder);
  }

  getBranchs() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({
      load: true,
      message: 'Getting Branch Details'
    })
    $.ajax({
      type: 'POST',
      data: { 'userId': userId },
      url: Server() + 'branchdetails/get.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data);
          context.setBranchData(data);
          context.setState({
            load: false,
            branchDataorignal: data
          });
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  setBranchData(data) {
    let datas = (ReadCookie("branch"));
    let branch_id;
    for (var i = 0; i < datas.length; i++) {
      branch_id = datas[i].branch_id;
    }
    let item = [];
    data.map((d) => {
      if (d.id == branch_id) {

      }
      else {
        item.push({key: d.name, text: d.name, value: d.id});
      }
    })
    this.setState({
      branchData: item,
    });
  }

  componentDidUpdate(props) {
    if (props.branch != this.props.branch) {
      this.getPurchaseRequest(1, this.state.orderElement, this.state.sortingOrder);
    }
  }

  handlePaginationChange = (e, { activePage }) => {
    this.getPurchaseRequest(activePage, this.state.orderElement, this.state.sortingOrder);
  }

  sorting(orderElement, sortingOrder) {
    if (sortingOrder == 'DESC') {
      this.setState({ sortingOrder: 'ASC' })
      this.getPurchaseRequest(1, orderElement, 'ASC');
    }
    else {
      this.setState({ sortingOrder: 'DESC' })
      this.getPurchaseRequest(1, orderElement, 'DESC');
    }
  }

  getPurchaseRequest(page, orderElement, sortingOrder) {
    let context = this;
    this.setState({
      load: true,
      openFollowup: false,
      message: 'Getting Purchase Details!!!!',
    });
    let data1 = { 'branch': this.props.branch, 'page': page,
                  'orderElement': orderElement, 'sortingOrder': sortingOrder };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/get.php',
      success: function(data)
      {
        let totalPages = 0;
        let totalPrice = 0;
        context.setState({
          load: false
        });
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
            totalPages = data[i].totalPages;
            let total = data[i].total;
            total = Number(total);
            totalPrice = totalPrice + total;
          }
          totalPages = Number(totalPages);
          totalPages = totalPages / 100;
          let roundOff = Math.round( totalPages );
          if (roundOff < totalPages) {
            roundOff++;
          }
          context.setState({
            data: data,
            totalPages: roundOff,
            totalPrice: totalPrice,
            serialNumber: (page * 100) - 100,
            pageNumber: page,
          });
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  handleClose = () => {
   this.setState({ addDialog: false, viewOpen: false, openFollowup: false, chooserequest: false });
  };


  requesttowho() {
    if (!this.props.menuPermission.add) {
      alert('Your not allow to purchase request');
      return;
    }
    this.setState({ chooserequest: true  })
    if (this.props.purchasefrompurchaser == 'show') {
      this.setState({ addDialog: true, requestTo: 'Purchaser' })
    }
    else if (this.props.purchasefrombranch == 'show') {
      this.setState({ addDialog: true, requestTo: 'Branch' })
    }
  }


  view(id) {
    let context = this;
    this.setState({
      load: true,
      message: 'Getting Purchase Details!!!!',
    });
    let data1 = { 'id': id };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/getpurchaserequest.php',
      success: function(data)
      {
        context.setState({
          load: false
        });
        try {
          data = JSON.parse(data);
          console.log(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({
            datas: data,
            viewOpen: true,
            viewId: id
          });
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  update(id, status) {
    let data = this.state.datas;
    for (var i = 0; i < data.length; i++) {
      if (data[i].id == id) {
        data[i].status = status;
      }
    }
    this.setState({ datas: data })
  }

  statusUpdates(items) {
    let data = this.state.datas;
    for (var i = 0; i < items.length; i++) {
      for (var j = 0; j < data.length; j++) {
        if (items[i].id == data[j].id) {
          data[j].status = items[i].status;
        }
      }
    }
    this.setState({ datas: data })
  }

  update1(data) {
    this.setState({
      data: data
    });
    this.handleClose();
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  }

  updateData(data) {
    this.view(data);
  }

  updateData1(data) {
    this.setState({ data: data });
  }

  requestTo(value) {
    this.setState({ addDialog: true, requestTo: value })
  }

  render() {
    let i = this.state.serialNumber;
    return (
      <div style={{padding: '2%'}}>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <div style={{display: this.props.temprequest}}>
            <Samplerequest display='none'
              orderElement={this.state.orderElement} sortingOrder={this.state.sortingOrder}
              getPurchaseRequest={this.getPurchaseRequest.bind(this)} />
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <Button primary fluid onClick={this.requesttowho.bind(this)}
              style={{display: this.props.pendingrequestedit}}>
              Add Purchase Request
            </Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <Showpendingstocks menuPermission={this.props.menuPermission} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <div style={{fontSize: 18, paddingTop: '5%', color: '#5D98E8'}}><b>{'₹ '+Math.round(Number(this.state.totalPrice).toFixed(1))}</b></div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <div id='scrolls'>
              <table width="100%" id='table' style={{display: this.props.pendingrequestview}}>
                <tr>
                  <th id='tableheader' style={{width: '7%'}}><center>S.no</center></th>
                  <th id='tableheader' style={{width: '7%'}} onClick={this.sorting.bind(this, 'timstamp', this.state.sortingOrder)}><center>Id</center></th>
                  <th id='tableheader' style={{width: '20%'}} onClick={this.sorting.bind(this, 'purchaser', this.state.sortingOrder)}><center>Purchaser</center></th>
                  <th id='tableheader' onClick={this.sorting.bind(this, 'order_by', this.state.sortingOrder)}><center>Ordered</center></th>
                  <th id='tableheader' onClick={this.sorting.bind(this, 'expected_delivary_date', this.state.sortingOrder)}><center>Exp. Deli.</center></th>
                  <th id='tableheader' onClick={this.sorting.bind(this, 'timstamp', this.state.sortingOrder)}><center>Order on</center></th>
                  <th id='tableheader' onClick={this.sorting.bind(this, 'stock', this.state.sortingOrder)} style={{width: '7%'}}><center>Item`s</center></th>
                  <th id='tableheader' onClick={this.sorting.bind(this, 'total', this.state.sortingOrder)}><center>Price</center></th>
                  <th id='tableheader' onClick={this.sorting.bind(this, 'followup', this.state.sortingOrder)}><center>Follow</center></th>
                  <th id='tableheader' style={{width: '7%'}}><center>Vouc.</center></th>
                  <th id='tableheader' style={{cursor: 'pointer', width: '5%'}}><center>View</center></th>
                </tr>
                { this.state.data.map((z) => {
                  let type = z.type;
                  let color = '#F9CABB';
                  if (type == 'Normal') {
                    color = '#FFFFFF';
                  }
                  if (this.state.pending) {
                    if (z.pending_stocks > 0) {
                      i++;
                      let date = z.expected_delivary_date;
                      date = date.split(' ')[0];
                      let timstamp = z.timstamp;
                      timstamp = timstamp.split(' ')[0];
                      return (
                        <tr style={{backgroundColor: color}}>
                          <td><center>{i}</center></td>
                          <td><center>{z.id}</center></td>
                          <td><center>{z.purchaser}</center></td>
                          <td><center>{z.name}</center></td>
                          <td><center>{date}</center></td>
                          <td><center>{timstamp}</center></td>
                          <td><center>{z.stock}</center></td>
                          <td><center>{Math.round(Number(z.total).toFixed(2))}</center></td>
                          <td id="pointer"
                              onClick={ () => { this.setState({ followupId: z.id, openFollowup: true }) }}>
                              <center>{z.followup}</center>
                          </td>
                          <td>
                            <center>
                              <Voucher update={this.updateData1.bind(this)}
                                requestid={z.id}
                                data={this.state.data} voucherno={z.voucher_no} />
                            </center>
                          </td>
                          <td style={{cursor: 'pointer', color: '#69A4B7'}} onClick={this.view.bind(this, z.id)}>
                          <center>View</center>
                          </td>
                        </tr>
                      );
                    }
                  }
                  else {
                    i++;
                    let date = z.expected_delivary_date;
                    date = date.split(' ')[0];
                    let timstamp = z.timstamp;
                    timstamp = timstamp.split(' ')[0];
                    return (
                      <tr style={{backgroundColor: color}}>
                        <td><center>{i}</center></td>
                        <td><center>{z.id}</center></td>
                        <td><center>{z.purchaser}</center></td>
                        <td><center>{z.name}</center></td>
                        <td><center>{date}</center></td>
                        <td><center>{timstamp}</center></td>
                        <td><center>{z.stock}</center></td>
                        <td><center>{Math.round(Number(z.total).toFixed(2))}</center></td>
                        <td id="pointer" onClick={ () => { this.setState({ followupId: z.id, openFollowup: true }) }}><center>{z.followup}</center></td>
                        <td>
                          <center>
                            <Voucher update={this.updateData1.bind(this)}
                            requestid={z.id} pendingrequestedit={this.props.pendingrequestedit}
                            voucherno={z.voucher_no} data={this.state.data} />
                          </center>
                        </td>
                        <td style={{cursor: 'pointer', color: '#568493'}} onClick={this.view.bind(this, z.id)}>
                        <center>View</center>
                        </td>
                      </tr>
                    );
                  }
                  })
                }
              </table>
            </div>
            <div align="right">
              <Pagination
                activePage={this.state.pageNumber}
                boundaryRange={this.state.boundaryRange}
                onPageChange={this.handlePaginationChange}
                siblingRange={this.state.siblingRange}
                totalPages={this.state.totalPages}
                ellipsisItem={this.state.showEllipsis ? undefined : null}
                prevItem={this.state.showPreviousAndNextNav ? undefined : null}
                nextItem={this.state.showPreviousAndNextNav ? undefined : null}
              />
            </div>
          </Grid.Column>
        </Grid>
        <Loading load={this.state.load} message={this.state.message} />

        <Followup followupId={this.state.followupId} data={this.state.data} update={this.update.bind(this)}
          handleClose={this.handleClose.bind(this)} openFollowup={this.state.openFollowup}
          orderElement={this.state.orderElement} sortingOrder={this.state.sortingOrder}
          pendingrequestedit={this.props.pendingrequestedit}
          view={this.view.bind(this)} getPurchaseRequest={this.getPurchaseRequest.bind(this)} />

        <Add addDialog={this.state.addDialog} branch={this.props.branch}
             branchData={this.state.branchData} requestTo={this.state.requestTo}
             orderElement={this.state.orderElement} sortingOrder={this.state.sortingOrder}
             getPurchaseRequest={this.getPurchaseRequest.bind(this)}
             handleClose={this.handleClose.bind(this)} viewEdits={this.props.viewEdits} />
        { this.state.datas ?
          (
            <div>
            <RequestDetails menuPermission={this.props.menuPermission} viewOpen={this.state.viewOpen} handleClose={this.handleClose}
                  data={this.state.datas} update={this.update.bind(this)}
                  view={this.view.bind(this)} viewId={this.state.viewId} updateData={this.updateData.bind(this)}
                  statusUpdates={this.statusUpdates.bind(this)} pendingrequestedit={this.props.pendingrequestedit}/></div>
          ) :
          (
            <div></div>
          )

        }
        <Dialog open={this.state.chooserequest} onClose={this.handleClose} aria-labelledby="simple-dialog-title">
          <DialogTitle id="simple-dialog-title" style={{width: 300}}>Request to</DialogTitle>
          <div>
            <List>
                <ListItem id='pointer' onClick={this.requestTo.bind(this, 'Purchaser')} style={{fontSize: 14, display: this.props.purchasefrompurchaser}}><b>Purchaser</b></ListItem>
                <ListItem id='pointer' onClick={this.requestTo.bind(this, 'Branch')} style={{fontSize: 14, display: this.props.purchasefrombranch}}><b>Branch</b></ListItem>
            </List>
          </div>
        </Dialog>

      </div>
    );
  }
}

export default Title;
